import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank"
import type { Draw, DrawMap, DrawOptions } from "leaflet"
import type { ReactElement } from "react"
import { useTranslation } from "react-i18next"
import { DrawShapeControl } from ".."
import { MapViewerPanel } from "../../../redux"
import { RectangleDrawOverwrite } from "../../../utils"

export function DrawSquareControl(): ReactElement {
  const { t } = useTranslation("map")
  const defaultSquareOptions: DrawOptions.RectangleOptions = {
    shapeOptions: {
      fill: false,
      fillOpacity: 0,
      color: "#000"
    }
  }

  function createSquareFeature(map: DrawMap): Draw.Feature {
    return new RectangleDrawOverwrite(map, defaultSquareOptions)
  }

  return (
    <DrawShapeControl
      controlPanel={MapViewerPanel.DrawSquare}
      tooltip={t("actionButtons.edit.square")}
      icon={<CheckBoxOutlineBlankIcon />}
      createFeature={createSquareFeature}
    />
  )
}
